import React from "react";

export default () => <h1>Enterprise Support Resource</h1>;
